import React, { useEffect } from 'react';
import styled from 'styled-components';
import lostLogo from "@/assets/lostLoogo.svg";
import closeModal from "@/assets/closeModal.svg";
import looseSound from "../../../assets/loosing sound.mp3";
import loosingGif from "../../../assets/merv_lose.gif";

interface LostModalProps {
  open: boolean;
  onClose: () => void;
  message: string;
}

const Modal = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
  padding: 1rem;
`;

const Container = styled.div<{ isOpen: boolean }>`
  background: rgba(5, 5, 24, 0.95);
  border-radius: 20px;
  max-width: 300px;
  width: 100%;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transform: ${props => props.isOpen ? 'scale(1)' : 'scale(0.9)'};
  opacity: ${props => props.isOpen ? 1 : 0};
  transition: transform 0.3s ease, opacity 0.3s ease;
  position: relative;
  overflow-y: auto;
  max-height: 90vh;

  @media (min-width: 600px) {
    padding: 2rem;
  }

  @media (max-width: 768px) {
    max-height: 80vh;
    height: 200px;
    overflow-y: hidden;
  }
  `;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  z-index: 1;
  
  img {
    width: 24px;
    height: 24px;
    }
    
    &:hover {
      opacity: 0.8;
      }
      `;

const Content = styled.div`
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.5rem;
      
      `;

const LosingAnimation = styled.div`
      width: 100%;
      max-width: 260px;
      margin: 0 auto;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 0 20px rgba(60, 55, 255, 0.3);
      
      img {
        width: 100%;
        height: auto;
        display: block;
        }
        
        @media (max-width: 768px) {
          height: 80%;
        }
        `;

const LostLogo = styled.img`
  width: 80px;
  height: 80px;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    width: 60px;
    height: 60px;
  }
`;

const Message = styled.h2`
  font-size: 20px;
  color: white;
  text-align: center;
  margin: 0;
  font-weight: bold;
  padding: 0 1rem;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const LostModal: React.FC<LostModalProps> = ({ open, onClose, message }) => {
  useEffect(() => {
    let audio: HTMLAudioElement | null = null;

    if (open) {
      audio = new Audio(looseSound);
      audio.play().catch((e) => console.log("Sound failed to play", e));
    }

    return () => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    };
  }, [open]);

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <Modal isOpen={open} onClick={handleOverlayClick}>
      <Container isOpen={open}>
        {/* <CloseButton onClick={onClose}>
          <img src={closeModal} alt="Close" />
        </CloseButton> */}
        <Content>
          <LosingAnimation>
            <img src={loosingGif} alt="Better luck next time" />
          </LosingAnimation>

          <Message>{message}</Message>

        </Content>
      </Container>
    </Modal>
  );
};

export default LostModal;